<template>
  <loading v-if="loading" :texto="'Cargando proyecto ' + $route.params.id"/>
  <div v-else>
    <h2 class="text-primary-dark seccion">Proyecto de {{ proyecto.ramo.nombre }}</h2>
    <div class="row">
      <div class="col-lg-4 col-md-6">
        <label class="label-ficha">Tomador</label>
        {{ proyecto.cliente.tomador }}
      </div>
      <div class="col-lg-4 col-md-6">
        <label class="label-ficha">Ramo</label>
        {{ proyecto.ramo.nombre }}
      </div>
      <div class="col-lg-2 col-md-6">
        <label class="label-ficha">Referencia</label>
        {{ proyecto.id }}
      </div>
      <div class="col-lg-2 col-md-6">
        <label class="label-ficha">Fecha</label>
        {{ proyecto.fechaApertura|fecha }}
      </div>
    </div>
    <hr/>
    <h5 class="text-primary-dark text-uppercase border-bottom text-center text-md-left">Alternativas de contratación</h5>
    <div class="text-center" v-if="proyecto.cotizacion.length == 0">
      Proyecto no cotizado
      <hr/>
    </div>
    <div class="row" v-else>
      <div class="col-md-12 text-center border-bottom pb-2">
        <a :href="urlComparativo" target="_blank" class="btn btn-primary text-uppercase">Documento comparativo</a>
      </div>
    </div>
    <div v-for="(cotizacion, index) in proyecto.cotizacion" :key="cotizacion.id" class="row border-bottom pb-2 mb-2 align-items-center" :class="{ 'bg-success-light': cotizacion.estado == 7, 'pt-2' : index == 0 }">
      <div class="col-sm-12 col-md-2 col-lg-1 text-center text-md-left">
        <logo-cia :id="cotizacion.compania.id" class="text-center text-md-left px-2" style="width: 80px; height: 20px;" :small="true"/>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-7 col-xl-8 text-center text-md-left">
        <h5 class="mb-0">{{ cotizacion.compania.nombre }}</h5>
      </div>
      <div class="col-sm-6 col-md-1 col-lg-1 text-center text-md-right text-nowrap font-weight-bold">
        <h5 class="mb-0">{{ cotizacion.primaAnual|decimal }} €</h5>
      </div>
      <div class="col-sm-6 col-md-3 col-lg-3 col-xl-2 text-center text-md-right text-nowrap font-weight-bold">
        <a  v-if="proyecto.estado == $store.getters.estados.proyectoAbierto && cotizacion.documentos[0]" :href="getUrlDetalle(cotizacion.documentos[0].id)" target="_blank" class="btn btn-primary mb-0 mr-3">Detalle</a>
        <router-link :to="{name: 'emitir', params: { proyecto: proyecto.id, cotizacion: cotizacion.id }}" class="btn btn-primary mb-0 text-uppercase" v-if="proyecto.estado == $store.getters.estados.proyectoAbierto">Emitir</router-link>
      </div>
    </div>
    
    <ul class="nav nav-tabs mt-3 mb-3">
        <li class="nav-item w-50 text-center text-md-left">
          <a class="nav-link text-dark" 
            :class="{ 'border-gris-claro': (tabActive != 'incidenciasCliente'), 'border-primary': (tabActive == 'incidenciasCliente'),'active': (tabActive == 'incidenciasCliente') }" 
            @click="selectTab('incidenciasCliente')" href="javascript:void(0)">
            <span class="d-none d-md-inline"><font-awesome-icon icon="comments"/> Notas</span>
            <font-awesome-icon icon="comments" class="py-1 fa-2x text-gris-claro d-inline d-md-none"/>
          </a>
        </li>
        <li class="nav-item w-50 text-center text-md-left">
          <a class="nav-link text-dark" 
            :class="{ 'border-gris-claro': (tabActive != 'documentos'), 'border-primary': (tabActive == 'documentos'),'active': (tabActive == 'documentos') }" 
            @click="selectTab('documentos')" href="javascript:void(0)">
            <span class="d-none d-md-inline"><font-awesome-icon icon="paperclip"/> Documentos</span>
            <font-awesome-icon icon="paperclip" class="py-1 fa-2x text-gris-claro d-inline d-md-none"/>
            </a>
        </li>
      </ul>
      <div class="tab-content px-0">
        <div class="tab-pane" :class="{ 'show': (tabActive == 'incidenciasCliente'), 'active': (tabActive == 'incidenciasCliente') }">
          <incidencias-cliente :idObjeto="proyecto.id" tipoObjeto="160"/>
        </div>
        <div class="tab-pane" :class="{ 'show': (tabActive == 'documentos'), 'active': (tabActive == 'documentos') }">
          <documentos-item :idObjeto="proyecto.id" tipoObjeto="160"/>
        </div>
      </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import util from '@/util'
import Loading from '@/components/widgets/Loading'
import LogoCia from '@/components/widgets/LogoCia'
import DocumentosItem from '@/components/comunes/DocumentosItem'
import IncidenciasCliente from '@/components/comunes/IncidenciasCliente'
export default {
  data() {
    return {
      loading: true,
      proyecto: {},
      tabActive: 'incidenciasCliente'
    }
  },
  computed: {
    ...mapGetters({
      urlBase: 'urlBase',
      credentials: 'credentials'
    }),
    urlComparativo() {
      let url = this.urlBase + 'oportunidades/' + this.$route.params.id + '/comparativo?token='+this.credentials.token;
      return url;
    }
  },
  mounted() {
    if (this.proyecto && this.proyecto.id == this.$route.params.id) {
      this.loading = false;
    } else {
      this.proyecto = {};
    }
    this.getProyecto(this.$route.params.id);
  },
  methods: {
    getUrlDetalle(id) {
      return this.urlBase + 'archivodocumental/' + id + '?token=' + this.credentials.token
    },
    getProyecto(id) {
      let grupos = [
        'oportunidad.cotizacion',
        'oportunidad.ramo',
        'cotizacion.compania',
        'cotizacion.producto',
        'cotizacion.documentos'
      ]
      let params = {
        'grupos': grupos.join(',')
      }
      let url = this.urlBase + 'oportunidades/' + id + '?' + util.objToQuery(params)
      this.$http.get(url).then(
          (response) => {
            this.proyecto = response.body
            this.loading = false
          },
          (error) => {
            this.loading = false
            if (error.status === 401) {
              this.$router.push({name:'Login'})
            }
          }
      );
    },
    selectTab(tab) {
      this.tabActive = tab;
    }
  },
  components: {
    Loading,
    LogoCia,
    DocumentosItem,
    IncidenciasCliente
  }
}
</script>
